export interface TableColumn {
  label: string;
  field: string;
  width?: string;
  sortable?: boolean;
  hidden?: boolean;
  tooltip?: string;
  thClass?: string;
  tdClass?: string;
  formatFn?: (v: any) => void;
}

export interface DropdownOption {
  label: string;
  value: any;
}

export enum EnvironmentMode {
  SANDBOX = "sandbox",
  LIVE = "live",
}

export enum CoreProducts {
  DISBURSE = "disbursement",
  DIRECT = "direct",
  STATEMENT = "statement",
}

export interface TransactionFile {
  name: string;
  content: string;
  size: number;
}

export enum EAvailableSectionFormatTypes {
  FILE = "file",
  URL = "url",
  PHONE = "phone",
  TAX_ID = "taxId",
}

export type TFile = File | null;

export interface ISectionFormatObj {
  type: EAvailableSectionFormatTypes;
  fileName?: string;
  fileData?: string | File;
  url?: string;
  phone?: string;
  taxId?: string;
}

export type TFileUpload = {
  file: TFile;
  signedUrl?: string;
  fileName?: string;
  id?: string;
  index?: number;
};
